import { Pagination } from "@/domain/entities/Pagination";
import { QueryParamsEntities } from "./MainApp";

export class CariSttEntities {
  pagination: Pagination;
  data: ListCariSTT[];
  constructor(pagination: Pagination, data: ListCariSTT[]) {
    this.pagination = pagination;
    this.data = data;
  }
}
export class ListCariSTT {
  manifestId = 0;
  manifestNo = "";
  totalStt = 0;
  totalPieces = 0;
  totalSttHanging = 0;
  createdAt = "";
  createdByUsername = "";

  constructor(fields?: Partial<ListCariSTT>) {
    Object.assign(this, fields);
  }
}

export class CariSttRequest {
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";
  search = "";
  constructor(fields?: Partial<CariSttRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class DetailSttScan {
  manifestId = 0;
  manifestNo = ""
  partnerName = "";
  partnerCity3lc = "";
  partnerCityName = "";
  totalStt = 0;
  totalKoli = 0;
  totalPieces = 0;
  totalSttHanging = 0;
  totalKoliHanging = 0;
  totalPiecesHanging = 0;
  createdAt = "";
  createdByUsername = "";
  sttList = [] as DetailStt[];

  constructor(fields?: Partial<DetailSttScan>) {
    Object.assign(this, fields);
  }
}

export class DetailStt {
  sttNo = "";
  referenceNo = "";
  shipmentType = "";
  lastStatus = "";
  hangingDays = 0;
  hangingType = "";
  originCity3lc = "";
  destinationCity3lc = "";

  constructor(fields?: Partial<DetailStt>) {
    Object.assign(this, fields);
  }
}

export class SearchSttScan {
  sttNo = "";
  status = "";
  daysHanging = 0;
  scanLocation = "";
  lastStatus = "";
  note = "";
  lastScanAt = "";
  pieces = 0;

  constructor(fields?: Partial<SearchSttScan>) {
    Object.assign(this, fields);
  }
}

export class SearchSttListSummaryDetail {
  totalStt = 0;
  totalPieces = 0;

  constructor(fields?: Partial<SearchSttListSummaryDetail>) {
    Object.assign(this, fields);
  }
}

export class SearchSttListSummary {
  hanging = new SearchSttListSummaryDetail();
  nonHanging = new SearchSttListSummaryDetail();

  constructor(fields?: Partial<SearchSttListSummary>) {
    Object.assign(this, fields);
  }
}

export class SearchSttList {
  summary = new SearchSttListSummary();
  data: SearchSttScan[] = [];

  constructor(fields?: Partial<SearchSttList>) {
    Object.assign(this, fields);
  }
}
